<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { MeetingEntry, MeetingSuggestion } from '@/graphql/custom-types';
import SuggestionsOverlay from '@/views/meetings/SuggestionsOverlay.vue';
import { ref } from 'vue';

const showSuggestionsOverlay = ref<boolean>(false);

interface Props {
  suggestions: MeetingSuggestion[];
  meeting: MeetingEntry;
}

const props = withDefaults(defineProps<Props>(), {});
</script>

<template>
  <div>
    <BasicBlock
      :icon="['fal', 'lightbulb']"
      :ariaDescription="$t('meeting.suggestion')"
      canTriggerOverlay
      :text="$t('meeting.suggestionItems', props.suggestions.length)"
      @click="showSuggestionsOverlay = true"
    />

    <SuggestionsOverlay
      v-if="showSuggestionsOverlay"
      :meeting="meeting"
      :suggestions="suggestions"
      @close="showSuggestionsOverlay = false"
    />
  </div>
</template>
